import dayjs from 'dayjs';
import {MRT_Row} from 'material-react-table';
import React from 'react';
import {MONTH_SHORT_DAY_YEAR_FORMAT} from '@/config/timeFormats';
import type CreatorGroupMembership from '@/types/creatorGroupMembership';

function DateAddedCell({row}: {row: MRT_Row<CreatorGroupMembership>}) {
  return (
    <>{dayjs(row.original.createdAt).format(MONTH_SHORT_DAY_YEAR_FORMAT)}</>
  );
}

export default DateAddedCell;
